<template>
  <ng-table
    class="ng-table"
    :columns="columns"
    :params="params"
    :rowKey="row => row.lib_id"
    :request="$axios.LibraryManage_list"
    :load.sync="loadTable"
    :reload.sync="reloadTable"
    :scroll="{y: scrollyHeight - 20}"
    @data-change="requestSuccess"
  >
    <!-- 头像 -->
    <template slot="profile_photo" slot-scope="text, scope">
      <ng-image
        class="table-header"
        :src="scope.logo_url ? `${scope.logo_url}?x-oss-process=style/thumb_10` : $var.defaultHeader"
        @error="({target}) => target.src = $var.defaultHeader"
      />
    </template>

    <template slot="name" slot-scope="text, scope">
      <!-- ?user_id=${scope.user_id}&supplier_type=${user_id ? supplierType : 'manage'}` /${supplierType}/${$route.params.user_id} -->
      <router-link :to="`/librarydetail/${scope.lib_id}?price=1`">{{text}}</router-link>
    </template>

    <template slot="contract_data.auth_type" slot-scope="text">
      <span>{{text | toAuthType}}</span>
    </template>

    <template slot="contract_data.auth_area" slot-scope="text">
      <span>{{text | toArea}}</span>
    </template>

    <template slot="deadline" slot-scope="text, scope">
      <span>
        {{scope.contract_data.coop_start_date || $config.emptyText}} -
        <br />
        {{scope.contract_data.coop_end_date || $config.emptyText}}
      </span>
    </template>

    <template slot="contract_data.auth_scene" slot-scope="text, scope">
      <div v-for="(item, index) in scope.contract_data.auth_scene" :key="index">
        <span>{{item.type | toAuthScene}}：</span>
        <span>{{item.ratio ? `${item.ratio}%` : $config.emptyText}}</span>
      </div>
    </template>

    <template slot="status" slot-scope="text">
      <span>{{text | toSellStatus}}</span>
    </template>

    <template slot="is_price" slot-scope="text">
      <span>{{text | toPriceStatus}}</span>
    </template>

    <template
      v-if="$root.$checkAuth($auth[authName] && $auth[authName].customePriceInfo)"
      slot="operation"
      slot-scope="text, scope"
    >
      <!-- <a-button type="link" @click="setPay(scope)">配置售价</a-button> -->
      <a-button
        v-if="scope.is_price == $val.CommonCheck.fail"
        type="link"
        @click="setPay(scope)"
      >配置售价</a-button>
      <router-link
        v-else
        :to="`/goods/sellway?goods_id=${scope.lib_id}&goods_type=${$val.Good_type.lib}&done_price=${scope.is_price}`"
      >配置售价</router-link>
    </template>
  </ng-table>
</template>

<script>
  import {tableMixins} from '@/mixins';

  import {AuthAreaOptions, AuthTypeOptions, BusinessSceneOptions, SellStatusOptions, PriceStatue} from '@/config/options';
  import {toOptionName} from '@/utils/function';

  import * as TabCol from '@/config/columns';

  const columns = [
    TabCol.colId,
    TabCol.portrait('封面', 'profile_photo'),
    TabCol.commonKey('曲库名称', 'name', {ellipsis: true, isSlot: true}),
    TabCol.commonKey('授权地域', 'contract_data.auth_area', null, true),
    TabCol.commonKey('授权类型', 'contract_data.auth_type', null, true),
    TabCol.commonKey('合作期限', 'deadline', null, true),
    TabCol.commonKey('授权场景&分成比例', 'contract_data.auth_scene', '180px', true),
    TabCol.commonKey('定价状态', 'is_price', '', true),
    TabCol.commonKey('售卖状态', 'status', '', true),
    TabCol.operation('100px'),
  ];

  export default {
    data() {
      return {
        columns,
        tableList: [],
        handleData: {},
        params: {},
      }
    },

    props: {
      authName: String,
      scrollyHeight: {
        type: Number,
        default: 400
      },
      reload: Boolean,
      user_id: String,
    },

    mounted() {
      let user_id = this.user_id;
      let params = {page: this.$route.query.page || 1};

      user_id && (params.user_id = user_id || 0)

      this.params = params;
    },

    filters: {
      toArea(value) {
        return toOptionName(AuthAreaOptions, value);
      },

      toAuthType(value) {
        return toOptionName(AuthTypeOptions, value);
      },

      toAuthScene(value) {
        return toOptionName(BusinessSceneOptions, value);
      },

      toSellStatus(value) {
        return toOptionName(SellStatusOptions, value);
      },

      toPriceStatus(value) {
        return toOptionName(PriceStatue, value);
      }
    },

    computed: {
      fromSuppllier() {
        return !!this.user_id;
      },
    },

    mixins: [
      tableMixins
    ],

    methods: {

      // goBatch(scope) {
      //   this.$router.push({
      //     name: 'librarybatch',
      //     params: {
      //       user_id: scope.user_id,
      //       type: this.$route.params.type,
      //       lib_id: scope.lib_id
      //     }
      //   })
      // },

      setPay(scope) {
        let obj = Object.assign({}, scope, {
          goods_type: this.$val.Good_type.lib,
          goods_id: scope.lib_id
        })

        this.$emit('goPay', obj);
      },

      handleFunc(key, scope) {
        this.$emit('handle', Object.assign(scope, {
          handleName: key
        }))
      },

      onDelete(/* scope */) {
        // let vm = this;
        this.$message.warning('暂未开发');

        // this.$confirm({
        //   width: '480px',
        //   title: '确认要删除该部门吗？',
        //   content: '删除该部门，部门关联的子部门及角色数据，会同步删除。',
        //   onOk() {
        //     return new Promise(resolve => {
        //       vm.deleteMember(scope, resolve);
        //     });
        //   }
        // });
      },

      // deleteMember(scope, next) {
      //   this.$message.warning('未添加');

      //   this.$axios.Account_delDepartment({dept_id: scope.dept_id}).then(res => {
      //     const data = res.data;

      //     if (data && data.code == 0) {
      //       this.$message.success('已成功删除该部门');
      //       next();

      //       setTimeout(() => {
      //         this.loadTableData();
      //       }, 500);
      //     }
      //   })
      // },

      requestSuccess(data) {
        this.tableList = data.data.list ? data.data.list : [];
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .ant-table td {
    white-space: nowrap;
  }
</style>
